export const entityNameToEntity = {
    'candidate': 'candidates',
    'vacancy': 'vacancies',
    'business': 'businesses',
    'business_unit': 'business_units',
    'contact': 'contacts',
    'offer': 'offers'
};